<div class="encabezado">
  <div>
    <div>
      <div>
        <h5 class="titulo1">{{ "titles-menu-pages.invoices" | translate }}</h5>
      </div>
    </div>
  </div>
  <div class="">
    <div class="">
      <div class="row">
        <div class="col-8">
          <app-filter [ladata]="ladata" (filterChanged)="filterChanged($event)"></app-filter>
        </div>
        <div class="col-4" *ngIf="accountType == 'broker'">
          <div class="btn-izq">
            <button class="btn btn-hover" type="button" (click)="toggleForm()">
              {{ "buttons.add+" | translate }} <i class="icon-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="showAlertFilter">
      <div class="col-12">
        <div class="alert alert-warning alert-dismissible fade show" role="alert">
          <div *ngIf="showCountFilter > 0"> <span>{{ "filter.part1" | translate }} <strong>{{showCountFilter}} {{
                "filter.part2_" + typeInvoices | translate }}</strong></span> {{ "filter.part3" | translate }} <span
              *ngIf="showAlertFilterAll">{{
              "filter.part4" | translate }} <strong> <a routerLink="/orders/all"> {{
                  "filter.part5" | translate }}</a> </strong></span></div>



          <div *ngIf="showCountFilter == 0"><span> <strong>{{ "filter.part6" | translate }} {{"filter.part2_" +
                typeInvoices
                |
                translate }}</strong>{{ "filter.part3" | translate }} </span> <span *ngIf="showAlertFilterAll"> {{
              "filter.part4" | translate }} <strong> <a routerLink="/orders/all"> {{
                  "filter.part5" | translate }}</a> </strong></span>
          </div>

        </div>
      </div>
    </div>

    <div class="tabla">
      <div class="table-responsive-wrapper">
      <table mat-table class="full-width-table" matSort aria-label="Brands" multiTemplateDataRows
        [dataSource]="dataSource">

        <!-- serial Column -->
        <ng-container matColumnDef="serial">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.serial" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row?.serial">
              {{ row?.serial }}
            </span>
          </td>
        </ng-container>

        <!-- number Column -->
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.number" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row?.number">
              {{ row?.number }}
            </span>
          </td>
        </ng-container>

        <!-- organization Column -->
        <ng-container matColumnDef="organization">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.organization" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <!-- <span *ngIf="row?.organization">
              {{ row?.organization }}
            </span> -->

            <div class="column-list">
              <span *ngIf="row?.organization">
                {{ row?.organization?.name }} </span>

              <div class="d-flex flex-column" *ngIf="expandedRow ? expandedRow.reference == row.reference : false">
                <span *ngIf="row?.organization?.billing_address" class="secondary-text">
                  {{ row?.organization?.billing_address }}</span>

                <span *ngIf="row?.organization?.billing_city" class="secondary-text">
                  {{ row?.organization?.billing_city }}</span>

                <span *ngIf="row?.organization?.billing_state" class="secondary-text">
                  {{ row?.organization?.billing_state }}</span>

                <span *ngIf="row?.organization?.tax_id" class="secondary-text">
                  {{ row?.organization?.tax_id }}</span>
              </div>

            </div>
          </td>
        </ng-container>

        <!-- dealership Column -->
        <ng-container matColumnDef="dealership">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.dealership" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">

            <div class="column-list">
              <span *ngIf="row?.dealership">
                {{ row?.dealership?.name }}
              </span>

              <div class="d-flex flex-column" *ngIf="expandedRow ? expandedRow.reference == row.reference : false">
                <span *ngIf="row?.dealership?.billing_address" class="secondary-text">
                  {{ row?.dealership?.billing_address }}</span>

                <span *ngIf="row?.dealership?.billing_city" class="secondary-text">
                  {{ row?.dealership?.billing_city }}</span>

                <span *ngIf="row?.dealership?.billing_state" class="secondary-text">
                  {{ row?.dealership?.billing_state }}</span>

                <span *ngIf="row?.dealership?.tax_id" class="secondary-text">
                  {{ row?.dealership?.tax_id }}</span>
              </div>

            </div>
          </td>
        </ng-container>

        <!-- date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.date" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row?.date">
              {{ row?.date | date: 'yyyy-MM-dd' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="commission">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.importe" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row?.total">
              {{ row?.total }} €
            </span>
          </td>
        </ng-container>

        <!-- updated_at Column -->
        <ng-container matColumnDef="updated_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.updated_at" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="d-flex flex-column"
              *ngIf="expandedRow ? expandedRow.reference == row.reference : false ; else notExpanded">
              <div class="column-list">
                <span *ngIf="row?.updated_at">
                  {{ row?.updated_at }}
                </span>
                <span *ngIf="row?.updated_at" class="secondary-text">
                  <i class="icon-user"></i>
                  {{ row?.updated_by }}
                </span>
              </div>
            </div>
            <ng-template #notExpanded>
              <div class="column-list">
                <span *ngIf="row?.updated_at">
                  {{ row?.updated_at | date: 'yyyy-MM-dd' }}
                </span>
                <span *ngIf="row?.updated_at" class="secondary-text">
                  <i class="icon-user"></i>
                  {{ row?.updated_by }}
                </span>
              </div>


            </ng-template>

          </td>
        </ng-container>

        <!-- stage_updated_at Column -->
        <ng-container matColumnDef="stage_updated_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.stage_updated_at" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">

            <div class="d-flex flex-column"
              *ngIf="expandedRow ? expandedRow.reference == row.reference : false; else notExpanded1">
              <div class="column-list">
                <span *ngIf="row?.stage_updated_at">
                  {{ row?.stage_updated_at }}</span>
                <span *ngIf="row?.stage_updated_by" class="secondary-text">
                  <i class="icon-user"></i> {{ row?.stage_updated_by }}</span>
              </div>
            </div>
            <ng-template #notExpanded1>
              <div class="column-list">
                <span *ngIf="row?.stage_updated_at">
                  {{ row?.stage_updated_at | date: 'yyyy-MM-dd' }}</span>
                <span *ngIf="row?.stage_updated_by" class="secondary-text">
                  <i class="icon-user"></i> {{ row?.stage_updated_by }}</span>
              </div>

            </ng-template>


          </td>
        </ng-container>

        <!-- stage Column -->
        <ng-container matColumnDef="stage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.stage" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <span class="badge text-badge-list" [ngClass]="row.stage | badgeColor:row.require_action:row.priority">{{
              "badge-status_select-stage." + row?.stage | translate
              }}</span>
          </td>
        </ng-container>

        <!-- actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.actions" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <i class="icon-pencil text-success icon-actions" (click)="getInvoice(row.reference)" aria-hidden="true"></i>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="toggleRow(row)"
          [ngClass]="{'tr-selected': expandedRow?.reference === row.reference}"></tr>
        <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> -->

      </table>
      </div>

      <mat-paginator [length]="paginator.length ? paginator.length : 25" [pageSize]="paginator.pageSize"
        [pageSizeOptions]="paginator.pageSizeOptions" (page)="onPageChange($event)">
      </mat-paginator>
    </div>


  </div>

  <div class="formulario-derecha-container" [ngClass]="{ 'mostrar-formulario': showForm }">
    <app-form-add-invoices *ngIf="showForm" [invoiceData]="invoiceData" [tab]="tab"
      (backButtonClick)="cerrarFormulario()" (addInvoice)="refrescar()" (invoiceCreated)="getInvoice($event)" (openFormAddOrders)="OpenFormAddOrders()" [document_buttons_chico]="document_buttons_chico"
      [ladata]="ladata"></app-form-add-invoices>
  </div>

  <div class="formulario-sub-derecha-container" [ngClass]="{'mostrar-formulario': showAddOrderForm }">
    <app-form-add-orders *ngIf="showAddOrderForm" [invoiceData]="invoiceData" [ladata]="ladata" (updatedOrders)="refreshInvoice()" (backButtonClick)="cerrarOrdersFormulario()"
    ></app-form-add-orders>
  </div>


  <div class="overlay" *ngIf="showForm || showAddOrderForm" (click)="cerrarFormulario()"></div>
</div>
